import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import "../pages/Home.css";
import logo from "../assets/servizy-logo.png"; // ✅ correct path

import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowUp,
} from "react-icons/fa";

const Footer = () => {
  const [showButton, setShowButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const goBookingLogin = () => {
    sessionStorage.removeItem("bookingCustomer");
    scrollToTop();
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer className="footer-main">
      <div className="footer-bg"></div>

      <div className="footer-container">
        <div className="footer-grid">

          {/* Logo Section */}
          <div className="footer-column">
            <NavLink
  to="/"
  className="footer-logo-link"
  onClick={scrollToTop}
>
  <img src={logo} alt="Servizy Logo" className="footer-logo-img" />
</NavLink>

            <p className="description" style={{ color: "#ffffff" }}>
              Professional mobile  repair service with free doorstep
              pickup and warranty protection.
            </p>

            <div className="social-row">
              <a
                className="social-icon"
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF />
              </a>

              <a
                className="social-icon"
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>

              <a
                className="social-icon"
                href="https://x.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaTwitter />
              </a>
            </div>
          </div>


          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>

            <ul>
              <li>
                <NavLink
                  className="footer-list-link"
                  to="/"
                  onClick={scrollToTop}
                >
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink
                  className="footer-list-link"
                  to="/about"
                  onClick={scrollToTop}
                >
                  About
                </NavLink>
              </li>

              <li>
                <NavLink
                  className="footer-list-link"
                  to="/services"
                  onClick={scrollToTop}
                >
                  Services
                </NavLink>
              </li>

              <li>
                <NavLink
                  className="footer-list-link"
                  to="/login"
                  onClick={goBookingLogin}
                >
                  Book Repair
                </NavLink>
              </li>

              <li>
                <NavLink
                  className="footer-list-link"
                  to="/track"
                  onClick={scrollToTop}
                >
                  Track Repair
                </NavLink>
              </li>
           
               
            </ul>
          </div>


          {/* Our Services */}
          <div className="footer-column">
            <h4>Our Services</h4>

            <ul>
              <li>
                <Link to="/services" onClick={scrollToTop}>
                  Screen Replacement
                </Link>
              </li>

              <li>
                <Link to="/services" onClick={scrollToTop}>
                  Battery Replacement
                </Link>
              </li>

             
              <li>
                <Link to="/services" onClick={scrollToTop}>
                  Water Damage Repair
                </Link>
              </li>

              <li>
                <Link to="/services" onClick={scrollToTop}>
                  Data Recovery
                </Link>
              </li>
            </ul>
          </div>


          {/* Contact Section */}
          <div className="footer-column">
            <h4>Contact Us</h4>

            <div className="contact-link">
              <FaPhoneAlt className="blue-icon" />
              <a
                className="footer-contact-link"
                href="tel:+919876543210"
              >
                +91 98765 43210
              </a>
            </div>

            <div className="contact-link">
              <FaEnvelope className="blue-icon" />
              <a
                className="footer-contact-link"
                href="mailto:support@myrepair.com"
              >
                support@servizy.com
              </a>
            </div>

            <div className="contact-link">
              <FaMapMarkerAlt className="blue-icon" />
              Bangalore, India
            </div>
          </div>

        </div>

        {/* Bottom */}
        <div className="footer-bottom">
  
  {/* Left Side */}
  <div className="footer-left">
    <Link to="/privacy-policy">Privacy Policy</Link>
    <span className="divider">|</span>
    <Link to="/terms">Terms & Conditions</Link>
  </div>

  {/* Right Side */}
  <div className="footer-right">
    © Copyright {new Date().getFullYear()} SERVIZY | Designed & Hosted By Web Universals.
  </div>

</div>
      </div>


      {/* Scroll Top Button */}
      {showButton && (
        <button className="back-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}

    </footer>
  );
};

export default Footer;